import React from 'react';
import EsDeskMonitor from './EsDeskMonitor';
// ISINMI — ES->NQ lull system (enters NQ off the ES signal). Grade A/B.
export default function IsinmiMonitor() { return <EsDeskMonitor system="isinmi" accent="#f97316" />; }
